import { createCustomEnum } from "./customEnum";

const BillingStatusTypes = createCustomEnum({
	pending: {
		value: 0,
		name: "pending",
		displayName: "Pending",
	},
	invoice_created: {
		value: 1,
		name: "invoice_created",
		displayName: "Invoice Created",
	},
	payment_received: {
		value: 2,
		name: "payment_received",
		displayName: "Payment Received",
	},
	payment_rejected: {
		value: 3,
		name: "payment_rejected",
		displayName: "Payment Rejected",
	},
	billed_to_aurora: {
		value: 4,
		name: "billed_to_aurora",
		displayName: "N/A - Billed to Aurora",
	},
});

export default BillingStatusTypes;
